import React from 'react';
import { Icon, IconProps } from '../Icon';

export const HomeOutlined: React.FC<IconProps> = (props) => {
  return (
    <Icon
      width="40"
      height="40"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M34.8261 15.5624C30.1326 11.5627 25.4404 7.56155 20.747 3.56154C20.3161 3.19563 19.6856 3.19563 19.2548 3.56154C14.563 7.56127 9.86911 11.5624 5.17567 15.5624C4.45653 16.1754 4.16663 16.8059 4.16663 17.7499V35.8396C4.16663 37.4268 5.45288 38.713 7.04007 38.713H32.9598C34.5471 38.713 35.8333 37.4268 35.8333 35.8396V17.7499C35.8349 16.8059 35.5436 16.1754 34.8261 15.5624ZM24.3127 36.9898H16.1261V27.077H24.3127V36.9898ZM34.1115 35.8398C34.1115 36.475 33.5967 36.9898 32.9615 36.9898H26.0378V26.5036C26.0378 25.8684 25.523 25.3536 24.8878 25.3536H15.5516C14.9164 25.3536 14.4016 25.8684 14.4016 26.5036V36.9898H7.04226C6.40864 36.9898 5.89226 36.475 5.89226 35.8398V17.7502C5.89226 17.3732 6.00948 17.1197 6.29619 16.8758C10.8647 12.9822 15.4329 9.08706 20.0014 5.1933C24.57 9.08848 29.1397 12.982 33.7083 16.8758C33.9966 17.1213 34.1122 17.3732 34.1122 17.7502V35.8398H34.1115Z" fill="#0C5026" />
    </Icon>
  );
};
